import React, { createContext } from 'react';
import { useGraphQL } from 'graphql-react';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const AuthContext = createContext({
    user: null,
    users: null
});

export default AuthContext;

export function AuthProvider({ children }) {
    if (process.env.EDITABLE === 'true') {
        return (
            <AuthProviderFn children={children}></AuthProviderFn>
        )
    }
    return (
        <>{children}</>
    )
}

function AuthProviderFn({ children }) {
    const { cacheValue } = useGraphQL({
        fetchOptionsOverride(request) {
            request.url = '/api/authx';
            request.credentials = 'include';
        },
        loadOnMount: true,
        operation: {
            query: `
				query {
					viewer {
						user {
							id
							name
							access
							roles {
								edges {
									node {
										name
										scopes
									}
								}
							}
						}
					}
				}
			`
        }
    });

    const user = cacheValue?.data?.viewer?.user
    if (user) {
        cookies.set('userName', user.name, { path: '/' });
        return (
            <AuthContext.Provider value={{ user }}>
                {children}
            </AuthContext.Provider>
        )
    } else {
        return (<div></div>)
    }
}